import React from 'react'
import "./TrackYourPeriod.css"

export default function TrackYourPeriod() {
return (
  <>
  <div className="TrackYourPeriod">
  </div>
  <div className="TrackYourPeriodHeading1">
        Track your period
  </div>
  <div className="TrackYourPeriodContent1">
      Stay in the know with reliable AI-based and science-backed period, ovulation, and PMS predictions. The intuitive design makes tracking your cycle effortless and helps you stay on top of your monthly data. 
  </div>
  <button className="TrackYourPeriodButton1"> 
    <span className='TrackYourPeriodButton1Text'>
        Track you period on the app
    </span>
  </button>
  <img className="TrackYourPeriodImage1" src = "./content/MenstrualCalender.svg" alt ="TrackYourPeriodImage"></img>
 
  </>
)
}
